import { RHTextField } from '../../../../../../dum';
import React from 'react';
import { useWatch } from 'react-hook-form';
import { IExpense, EXTERNAL_CODE, REQUIRE_EXTERNAL_CODE } from '../expense-form';
import { FIELD_LABELS, shortLabel } from '../../../../../../../helpers';

export function OrderCodeInput() {
    const requireExternalCode = useWatch({
        name: REQUIRE_EXTERNAL_CODE,
    }) as IExpense['require_supplement'];

    return (
        <RHTextField
            disabled={!requireExternalCode}
            name={EXTERNAL_CODE}
            label={shortLabel(FIELD_LABELS.external_code)}
        />
    );
}
